<template>
  <v-container class="container">
    <div class="font-weight-black" :class="[{ headline: $vuetify.display.xs }]" style="font-size: 36px">
      {{ (preferredFirstName || firstName) + ' ' + lastName || 'FirstName LastName' }}
    </div>
    <CompleteYourProfile
      v-if="collectDemographicInfo"
      :shouldRefreshData="shouldRefreshData"
      :learnerData="learnerData"
      @openModal="openCloseModal($event)"
    />
    <LearnerProfileInfo
      :learnerData="learnerData"
      :shouldRefreshData="shouldRefreshData"
      :collectDemographicInfo="collectDemographicInfo"
    />
    <ProfileCompletionModal
      v-if="completeProfile"
      :key="modalKey"
      :demographicInformation="demographicInfo"
      @closeModal="openCloseModal($event)"
      @close="closeDialog($event)"
    />
    <div v-show="false">{{ detectChange }}</div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue';

import { SessionInitializer } from '../mixins/sessionInitializer';
import CompleteYourProfile from './CompleteYourProfile.vue';
import LearnerProfileInfo from './LearnerProfileInfo.vue';
import ProfileCompletionModal from '../components/ProfileCompletionModal.vue';

export default defineComponent({
  name: 'ProfileDetails',

  data() {
    return {
      preferredFirstName: '',
      firstName: '',
      lastName: '',
      demographicInfo: {},
      completeProfile: false,
      modalKey: 0,
      isBeingDestroyed: false
    };
  },

  mixins: [SessionInitializer],
  components: { CompleteYourProfile, LearnerProfileInfo, ProfileCompletionModal },

  props: {
    name: String,
    learnerData: Object,
    collectDemographicInfo: Boolean,
    shouldRefreshData: {
      type: Boolean
    }
  },

  created() {
    ({
      firstName: this.firstName,
      lastName: this.lastName,
      preferredFirstName: this.preferredFirstName
    } = this.learnerData);
    this.demographicInfo = this.$conn.getDemographicInformation();
  },

  beforeUnmount() {
    this.isBeingDestroyed = true;
  },

  unmounted() {
    this.isBeingDestroyed = true;
  },

  methods: {
    openCloseModal() {
      if (this.isBeingDestroyed) return;

      if (this.completeProfile) {
        // Closing modal - force a new instance next time
        this.completeProfile = false;
        this.$nextTick(() => {
          this.modalKey++;
        });
      } else {
        // Opening modal
        this.modalKey++;
        this.completeProfile = true;
      }
    },
    async closeDialog(event) {
      if (this.isBeingDestroyed) return;

      this.completeProfile = !event;
      this.$nextTick(() => {
        this.modalKey++;
        this.$router.go();
      });
    }
  },

  computed: {
    detectChange() {
      if (this.shouldRefreshData) {
        ({
          firstName: this.firstName,
          lastName: this.lastName,
          preferredFirstName: this.preferredFirstName
        } = this.learnerData);
        this.getBasicAndDemograhicInfo();
      }

      return this.shouldRefreshData;
    }
  }
});
</script>

<style lang="stylus" scoped></style>
